
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"transform":"translate(4.803 -.197)"}},[_c('circle',{attrs:{"cx":"32","cy":"32","r":"32","transform":"translate(-4.803 .197)","fill":"#518bff"}}),_c('path',{staticClass:"bb",attrs:{"d":"M22.16 41.246v7.188a1.162 1.162 0 002.1.688l4.2-5.722zM45.308 14.165a1.163 1.163 0 00-1.209-.083L9.224 32.293a1.163 1.163 0 00.161 2.131l9.694 3.314 20.646-17.654-15.976 19.248 16.25 5.553a1.189 1.189 0 00.375.062 1.161 1.161 0 001.15-.99l4.26-28.673a1.164 1.164 0 00-.476-1.119z"}})])])
          )
        }
      }
    